/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { NgModule } from '@angular/core';
import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {NoAuthGuard} from './@shared/_guards/no-auth.guard';
import {AuthGuard} from './@shared/_guards/auth.guard';
import {HomeResolverService} from './@shared/_resolvers/home-resolver.service';
import {SpinnerComponent} from './@core/spinner/spinner.component';
import {HttpErrorsComponent} from './@shared/components/http-errors/http-errors.component';
import {MainLayoutComponent} from './@shared/components/layout/main-layout/main-layout.component';
import {AccountGuard} from './@shared/_guards/account.guard';

const appRoutes: Routes = [
  { path: 'eula/en', component: SpinnerComponent, resolve: {url: 'eulaUrlResolver'}, data: {lang: 'en'}, pathMatch: 'full'},
  { path: 'eula/hu', component: SpinnerComponent, resolve: {url: 'eulaUrlResolver'}, data: {lang: 'hu'}, pathMatch: 'full'},
  {
    path: '',
    loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)
  }, {
    path: '',
    canActivate: [ NoAuthGuard ],
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  }, {
    path: 'guide',
    loadChildren: () => import('./modules/guide/guide.module').then(m => m.GuideModule),
    data: { breadcrumb: 'guide.choiceAll.pageTitle' },
  }, {
    path: 'guest',
    loadChildren: () => import('./modules/guest/guest.module').then(m => m.GuestModule)
  }, {
    path: 'app',
    canActivate: [ AccountGuard ],
    loadChildren: () => import('./modules/app-area/app-area.module').then(m => m.AppAreaModule)
  },
  {
    path: '**',
    component: MainLayoutComponent,
    children: [{
      path: '',
      component: HttpErrorsComponent
    }]
  }
];

const config: ExtraOptions = {
  onSameUrlNavigation: 'reload'
};

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      config
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
